<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex" [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                    </div>
                </div>

                <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
</div>
<div class="container-fluid">
    <div class="row align-items-center justify-content-evenly">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <!-- <span class="mat-toolbar-row-separador"></span> -->
            <!-- <div class="mat-toolbar-custom"> -->
            <!-- <mat-toolbar>
                <mat-toolbar-row>

                    <span class="mat-toolbar-row-separador"></span>

                    <button (click)="dialogCuotasPlantas(1,null)" mat-flat-button
                        color="accent">{{Etiquetas.BotonACuotaPlanta}}</button>

                </mat-toolbar-row>

            </mat-toolbar> -->

            <mat-toolbar *ngIf="!isMobile()" class="justify-content-end">

                <button (click)="dialogCuotasPlantas(1,null)" style="margin-right: 1%" mat-flat-button
                    color="accent">{{Etiquetas.BotonACuotaPlanta}}</button>

                <button style="margin-right: 1%" mat-flat-button color="accent" [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu">
                    <span>Subida Masiva</span>

                </button>
                <mat-menu style="margin-right: 1%" #menu="matMenu">
                    <input #csvInput hidden="true" type="file" onclick="this.value=null"
                        (change)="aCuotasPlantasExcel($event)" accept=".xlsx" />
                    <button *ngIf="!isInRole('CONSULTOR')" [disabled]="loadingSubidaExcel" mat-menu-item color="accent"
                        (click)="csvInput.click()">
                        <mat-icon>attach_file</mat-icon>
                        <span>{{botonSubidaExcel}} </span>
                    </button>


                    <button *ngIf="!isInRole('CONSULTOR')" (click)="cPlantillaAltaMasiva()" mat-menu-item
                        color="accent">
                        <mat-icon>insert_drive_file</mat-icon>
                        <span>{{Etiquetas.BotonCPlantillaExcel}}</span>
                    </button>

                </mat-menu>

            </mat-toolbar>
            <mat-toolbar *ngIf="isMobile()">
                <mat-toolbar-row *ngIf="!isInRole('CONSULTOR')">

                    <button (click)="dialogCuotasPlantas(1,null)" mat-flat-button
                        color="accent">{{Etiquetas.BotonACuotaPlanta}}</button>
                </mat-toolbar-row>


                <mat-toolbar-row *ngIf="!isInRole('CONSULTOR')">
                    <button style="margin-right: 1%" mat-flat-button color="accent" [matMenuTriggerFor]="menu"
                        aria-label="Example icon-button with a menu">
                        <span>Subida Masiva</span>
                    </button>
                </mat-toolbar-row>

                <mat-toolbar-row>


                    <mat-menu #menu="matMenu">
                        <input #csvInput hidden="true" type="file" onclick="this.value=null"
                        (change)="aCuotasPlantasExcel($event)" accept=".xlsx" />
                    <button *ngIf="!isInRole('CONSULTOR')" [disabled]="loadingSubidaExcel" mat-menu-item color="accent"
                        (click)="csvInput.click()">
                        <mat-icon>attach_file</mat-icon>
                        <span>{{botonSubidaExcel}} </span>
                    </button>


                    <button *ngIf="!isInRole('CONSULTOR')" (click)="cPlantillaAltaMasiva()" mat-menu-item
                        color="accent">
                        <mat-icon>insert_drive_file</mat-icon>
                        <span>{{Etiquetas.BotonCPlantillaExcel}}</span>
                    </button>
                        

                    </mat-menu>
                </mat-toolbar-row>

            </mat-toolbar>
        </div>
    </div>

</div>


<div class="container-custom-content">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                <mat-form-field color="accent-darker" appearance="standard">
                    <mat-label>{{Etiquetas.Buscar}}</mat-label>
                    <input matInput (keyup)="applyFilter($event)" #input>
                </mat-form-field>
                <div class="mat-table-productos">
                    <table mat-table matTableResponsive [dataSource]="dataSource" matSort matSortActive="idProducto"
                        matSortDirection="asc">

                        <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Headers.Acciones}} </th>
                            <td mat-cell *matCellDef="let c">
                                <div>

                                    <button matTooltip="{{Tooltips.Editar}}" (click)="dialogCuotasPlantas(2, c)"
                                        mat-icon-button color="primary-darker">
                                        <mat-icon color="accent-darker">edit</mat-icon>
                                    </button>

                                    <button matTooltip="{{Tooltips.Eliminar}}" (click)="eliminar(c)" mat-icon-button
                                        color="primary-darker">
                                        <mat-icon color="accent-darker">delete</mat-icon>
                                    </button>

                                </div>

                            </td>
                        </ng-container>

                        <!-- <ng-container matColumnDef="idCompania">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                                {{Etiquetas.Headers.IdCompania}}
                            </th>
                            <td mat-cell *matCellDef="let c">{{c.idCompania}} </td>
                        </ng-container>
                        <ng-container matColumnDef="idSalesOrg">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> 
                                {{Etiquetas.Headers.IdSalesOrg}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.idSalesOrg}} </td>
                        </ng-container> -->
                        <ng-container matColumnDef="idPlanta">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.IdPlanta}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.idPlanta}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="idUbicacionAlmacenamiento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.IdUbicacionAlmacenamiento}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.idUbicacionAlmacenamiento}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="idProducto">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.IdProducto}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{ c.idProducto}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="producto">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.Producto}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.producto}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="mes">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.Mes}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.mes}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="anio">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.Anio}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.anio}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cantidadDisponibleVigente">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.CantidadDisponibleVigente}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.cantidadDisponibleVigente}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="cantidadPedidosNoFacturados">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.CantidadPedidosNoFacturados}}
                            </th>
                            <td (click)="dialogStockPedidos(c)" mat-cell *matCellDef="let c"
                                [ngClass]=" c.cantidadPedidosNoFacturados > 0 ? 'stockPedidos' : ''">
                                {{c.cantidadPedidosNoFacturados | number : '1.3-3'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="cantidadDisponibleVenta">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.CantidadDisponibleVenta}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.cantidadDisponibleVenta | number : '1.3-3'}}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let c; columns: displayedColumns;">
                        </tr>


                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumns.length">{{Etiquetas.SinRegistros}}
                            </td>
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                    </mat-paginator>
                </div>

            </div>

        </div>

    </div>

</div>